@if (alertDetalheErrosPedido === true) {
  <div class="body-alert">
    <div class="div-alert text-center lista-erros-cnpj">
      <p class="titulo-alert text-start">Benefícios ignorados</p>
      <div class="col-lg-12">
        <button class="fa fa-arrow-left botao-setinha-voltar btn-icon"
          (click)="fecharDetalhesBeneficio()"
          aria-label="Voltar">
        </button>
      </div>
      <table class="table table-hover table-responsive border-bottom">
        <caption>Tabela com lista de pedidos</caption>
        <thead>
          <tr>
            <th scope="col" class="border-top-0"></th>
            <th scope="col" class="border-top-0">CÓD.VENDA</th>
            <th scope="col" class="border-top-0">USUÁRIO</th>
            <th scope="col" class="border-top-0">VALOR</th>
            <th scope="col" class="border-top-0">MENSAGEM DE ERRO</th>
          </tr>
        </thead>
        <tbody>
          @for (erro of detalhesErroCnpj; track erro) {
            <tr>
              <td></td>
              <td>{{erro.codigoVenda}}</td>
              <td>{{erro.nomeUsuario}}</td>
              <td>{{erro.valorSubTotalProduto | currency: 'BRL'}}</td>
              <td>{{erro.descricaoMensagemErro}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
